module.exports = __webpack_public_path__ + "static/img/img_3.e1ccd43.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/enterprise/images/img_3.webp
// module id = J9Mo
// module chunks = 4